// Defined the Menus/routes
export enum IMenu {
    DASHBOARD = 'dashboard',
    ORDER = 'order',
    COMPANY = 'company',
    SERVICE_CENTER = 'service_center',
    EMPLOYEE = 'employee',
    PART = 'part',
    VENDOR = 'vendor',
    SALE = 'sale',
    ORDER_SUMMARY = 'order_summary',
    SALE_REPORT = 'sale_report',
    PURCHASE_REPORT = 'purchase_report',
    CATEGORY = 'category',
    PART_COMPANY = 'part_company',
    CUSTOMER = 'customer',
    VOUCHER = 'voucher',
    INVOICE_UPDATE = 'invoice_update'

}

// Defined the SubMenus
export enum ISubMenu {
    ORDER_ADD = 'order_add',
    ORDER_ASSIGN = 'ORDER_ASSIGN',
    MANAGER_ADD = 'manager_add',
    RECEPTIONIST_ADD = 'receptionist_add',
    TECHNICIAN_ADD = "technician_add",
    VENDOR_ADD = 'vendor_add',
    SALE_PART = 'sale_parts',

}